export const editor = {
  block_format: {
    bulleted_list: 'Lista desordenada',
    check_list: 'Lista de tareas',
    code_block: 'Bloque de código',
    heading_1: 'Título 1',
    heading_2: 'Título 2',
    heading_3: 'Título 3',
    numbered_list: 'Lista numerada',
    paragraph: 'Párrafo',
    quote: 'Cita',
  },
  block_insert: {
    horizontal_rule: 'Línea horizontal',
    image: 'Imagen',
    insert: 'Insertar',
    table: 'Tabla',
  },
  cancel: 'Cancelar',
  characters: 'caracteres',
  clear_editor: 'Limpiar editor',
  clear_editor_description: '¿Estás seguro de querer limpiar el editor?',
  clear_formatting: 'Limpiar Formato',
  edit_mode: {
    edit_mode: 'Modo de edición',
    lock: 'Bloquear',
    read_only_mode: 'Modo de Solo Lectura',
    unlock: 'Desbloquear',
    view_only_mode: 'Modo de solo lectura',
  },
  element_format: {
    'Center Align': 'Alinear Centro',
    'Justify Align': 'Justificar',
    'Left Align': 'Alinear Izquierda',
    'Right Align': 'Alinear Derecha',
    indent: 'Sangría',
    outdent: 'Reducir Sangría',
  },
  font_color: {
    background_color: 'Color de fondo',
    text_color: 'Color del texto',
  },
  font_format: {
    bold: 'Negrita',
    italic: 'Cursiva',
    strikethrough: 'Tachado',
    underline: 'Subrayado',
  },
  history: {
    redo_apple: 'Rehacer (⇧⌘Z)',
    redo_windows: 'Rehacer (Ctrl+Y)',
    undo_apple: 'Deshacer (⌘Z)',
    undo_windows: 'Deshacer (Ctrl+Z)',
  },
  image: {
    add_alt_text: 'Agregar texto alternativo',
    alt_text: 'Texto alternativo',
    alt_text_description:
      'Describe la imagen para lectores de pantalla y buscadores. Dejalo vacío solo si la imagen es decorativa.',
    alt_text_placeholder: 'Texto alternativo descriptivo',
    alt_text_title: 'Texto alternativo de la imagen',
    confirm: 'Confirmar',
    image: 'Imagen',
    image_url: 'URL de la imagen',
    image_url_placeholder: 'ej. https://source.unsplash.com/random',
    insert_image: 'Insertar imagen',
  },
  link: {
    toggle_link: 'Alternar Enlace',
    url_placeholder: 'https://ejemplo.com',
  },
  placeholder: 'Escribe «/» para ver los comandos...',
  subsuper: {
    subscript: 'Subíndice',
    superscript: 'Superíndice',
  },
  table: {
    confirm: 'Confirmar',
    insert_table: 'Insertar tabla',
    number_of_columns: 'Número de columnas',
    number_of_columns_placeholder: 'Número de columnas (1-50)',
    number_of_rows: 'Número de filas',
    number_of_rows_placeholder: 'Número de filas (1-500)',
    table: 'Tabla',
  },
  media_hub: {
    title: 'Agregar imagen',
    tabs: {
      stock: 'Fotos de stock',
      ai: 'Generar con IA',
      url: 'URL',
    },
    stock: {
      search_placeholder: 'Buscar fotos...',
      no_results: 'No se encontraron imagenes para "{{query}}"',
      api_error: 'No se pudieron cargar las imagenes. Intenta de nuevo.',
      retry: 'Reintentar',
      powered_by: 'Con tecnologia de Magnific',
    },
    ai: {
      section_label: 'Sección de contexto',
      section_placeholder: 'Seleccioná una sección',
      section_none: 'General (sin sección específica)',
      prompt_label: 'Describe la imagen',
      prompt_placeholder: 'Una foto profesional de...',
      generate: 'Generar',
      regenerate: 'Regenerar',
      accept: 'Usar esta imagen',
      generating: 'Generando...',
      recent_title: 'Recientes',
      no_content_context: 'Guarda el contenido primero para generar imagenes con IA.',
    },
    alt_text_label: 'Texto alternativo',
    alt_text_placeholder: 'Describe esta imagen para accesibilidad',
    insert: 'Insertar imagen',
    inserting: 'Insertando...',
    download_error: 'Error al descargar la imagen. Intenta de nuevo.',
  },
  ai_edit: {
    placeholder: 'Pedile a la IA que edite...',
    editing: 'Editando...',
    accept: 'Aceptar',
    revert: 'Revertir',
    cancel: 'Cancelar',
  },
  ai_full_edit: {
    placeholder: 'Iterar...',
    iterating: 'Iterando sobre el contenido...',
    review: 'Revisá los cambios',
    accept: 'Aceptar',
    reject: 'Rechazar',
    cancel: 'Cancelar',
    diff: 'Diferencias',
    cursor_label: 'IA',
  },
  words: 'palabras',
} as const
